import { Injectable, Inject } from '@angular/core';
import 'rxjs/add/observable/throw';
import 'rxjs/Rx';  // use this line if you want to be lazy, otherwise:
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';  // debug
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/toPromise';
import { Observable, throwError } from 'rxjs';
import { HandleError, HttpErrorHandler } from 'mds-ui/app/shared/service/http-error-handler.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ApplicantVO, FileResponseVO, ApplicantSearchVO, ApplicantRes, ApplicantListingResponse, Reports } from '../../../fingerprint/models/application';
import { environment } from 'mds-ui/environments/environment';

import { catchError } from 'rxjs/operators';
import { DateTimeFormatPipe } from 'mds-ui/app/shared/pipes/date-time-format.pipe';
import { ApiResponse } from 'mds-ui/app/shared/model/apiresponse';
import { JWTService } from './jwt.service';



@Injectable()
export class LocationService {
    private handleError: HandleError;
    public applicant: ApplicantVO;
    public fileResponse: FileResponseVO;
    public applicantSearchVO: ApplicantSearchVO;
    public reports: Reports;
    flag: boolean;
    constructor(private _http: HttpClient, private httpErrorHandler: HttpErrorHandler,
        private jwtService: JWTService) {
        this.handleError = httpErrorHandler.createHandleError('LocationService');
    }

    private httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
            "Cache-Control": "no-cache",
            Pragma: "no-cache"
        })
    };

    locationInfoInit() {
        this.applicant = new ApplicantVO();
        this.reports = new Reports();
    }

    locationSave(applicant: ApplicantVO): Observable<any> {
        return this._http.post<ApplicantVO[]>(environment.locationInfoURL, applicant, this.httpOptions)
            .pipe(catchError(this.handleError('locationSave()', [])));
    }
    getApplicantById(id: number, reqUser: string): Observable<ApplicantVO[]> {
        return this._http.get<ApplicantVO[]>(
            environment.getApplicantByIdUrl + id + "?userName=" + reqUser, this.httpOptions)
            .pipe(
                catchError(this.handleError('getApplicantById', []))
            );

    }
    downloadBCIA8016Form(applicantId: number, userName: string): Observable<FileResponseVO[]> {
        return this._http.get<FileResponseVO[]>(
            environment.getdownloadBCIA8016FormUrl + applicantId + "?userName=" + userName, this.httpOptions)
            .pipe(
                catchError(this.handleError('downloadBCIA8016Form', []))
            );
    }

    postBgCheckRequestDetails(applicant: ApplicantVO): Observable<any> {
        return this._http.post<ApplicantVO[]>(environment.postBgCheckRequestInfoURL, applicant, this.httpOptions)
            .pipe(catchError(this.handleError('postBgCheckRequestDetails()', [])));
    }

    getFingerprintList(applicantSearchVO: ApplicantSearchVO): Observable<ApplicantListingResponse[]> {
        return this._http.post<ApplicantListingResponse[]>(environment.getFingerprintListUrl, applicantSearchVO, this.httpOptions).pipe(
            catchError(this.handleError('getFingerprintList()', [])));
    }
    getFingerprintListCount(applicantSearchVO: ApplicantSearchVO): Observable<ApplicantListingResponse[]> {
        return this._http.post<ApplicantListingResponse[]>(environment.getFingerprintListUrl+"/count", applicantSearchVO, this.httpOptions).pipe(
            catchError(this.handleError('getFingerprintList()', [])));
    }
    getApplicantByPersonId(id: number, reqUser: string): Observable<ApplicantVO[]> {
        return this._http.get<ApplicantVO[]>(
            environment.getApplicantByIdUrl + "person/" + id + "?userName=" + reqUser, this.httpOptions)
            .pipe(
                catchError(this.handleError('getApplicantByPersonId', []))
            );

    }
    getApplicantsByPersonId(id: number, reqUser: string): Observable<any> {
        return this._http.get<any>(
            environment.getApplicantsByIdUrl + id + "?userName=" + reqUser, this.httpOptions)
            .pipe(
                catchError(this.handleError('getApplicantsByPersonId', []))
            );
    }
    // setheaders() {
    //     this.httpOptions = {
    //         headers: new HttpHeaders({
    //             'Content-Type': 'application/json',
    //             "Cache-Control": "no-cache",
    //             Pragma: "no-cache",
    //             'Authorization': `Bearer ` + this.jwtService.jwtToken.jwt_token
    //         })
    //     }
    // }
}